import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkAll", "checkOne", "bulkActions", "bulkForm", "bulkPlanTypeId"];

  checkAll(event) {
    const isChecked = event.target.checked;

    this.checkOneTargets.forEach((checkbox) => {
      checkbox.checked = isChecked;
    });

    this.#updateBulkActionsVisibility();
  }

  checkOne() {
    this.checkAllTarget.checked = this.checkOneTargets.every((checkbox) => checkbox.checked);
    this.#updateBulkActionsVisibility();
  }

  submitBulkMoveTo(event) {
    event.preventDefault();

    const planTypeId = event.target.dataset.value;

    if (!planTypeId) {
      return;
    }

    const selectedCheckboxes = this.#getSelectedCheckboxes();
    const membershipPlanIds = selectedCheckboxes.map((checkbox) => checkbox.value);

    if (membershipPlanIds.length === 0) {
      return;
    }

    const form = this.bulkFormTarget;

    form.querySelectorAll('input[name="membership_plan_ids[]"]').forEach((input) => input.remove());

    membershipPlanIds.forEach((planId) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "membership_plan_ids[]";
      input.value = planId;
      form.appendChild(input);
    });

    this.bulkPlanTypeIdTarget.value = planTypeId;

    form.requestSubmit();

    this.#uncheckAll();

    this.bulkActionsTarget.classList.add("hidden");
  }

  #updateBulkActionsVisibility() {
    const selectedCheckboxes = this.#getSelectedCheckboxes();
    const count = selectedCheckboxes.length;

    if (count > 0) {
      this.bulkActionsTarget.classList.remove("hidden");
    } else {
      this.bulkActionsTarget.classList.add("hidden");
    }
  }

  #getSelectedCheckboxes() {
    return this.checkOneTargets.filter((checkbox) => checkbox.checked);
  }

  #uncheckAll() {
    this.checkAllTarget.checked = false;
    this.checkOneTargets.forEach((checkbox) => {
      checkbox.checked = false;
    });
  }
}
